import {useEffect} from 'react'

type UseSyncCookiesFromCustomerDataOptions<TCookie, TCookieFromCustomerProfile> = {
    isParamsInUrl: boolean
    isRegistered: boolean
    customerDataValue: TCookieFromCustomerProfile | null
    setCookiesFromCustomerData: (value: TCookieFromCustomerProfile) => void
    getCookieValuesFromStorage: () => TCookie | undefined
    setCookieValuesState: (value: TCookie | undefined) => void
    setContextState?: (value: TCookie) => any
}

export function useSyncCookiesFromCustomerData<TCookie, TCookieFromCustomerProfile>({
    isParamsInUrl,
    isRegistered,
    customerDataValue,
    setCookiesFromCustomerData,
    getCookieValuesFromStorage,
    setCookieValuesState,
    setContextState
}: UseSyncCookiesFromCustomerDataOptions<TCookie, TCookieFromCustomerProfile>) {
    useEffect(() => {
        if (isParamsInUrl || !isRegistered || !customerDataValue) return

        setCookiesFromCustomerData(customerDataValue)

        const timeout = setTimeout(() => {
            const values = getCookieValuesFromStorage()
            setCookieValuesState(values)
            if (setContextState && values) {
                setContextState(values)
            }
        }, 0)

        return () => clearTimeout(timeout)
    }, [
        isParamsInUrl,
        isRegistered,
        customerDataValue,
        setCookiesFromCustomerData,
        getCookieValuesFromStorage,
        setCookieValuesState,
        setContextState
    ])
}
